// RECYX - Full Bilingual Translations (English / Kinyarwanda)
const T = {
  en: {
    // ── Nav ──
    nav: {
      home: "Home",
      marketplace: "Marketplace",
      technicians: "Technicians",
      map: "Map",
      dashboard: "Dashboard",
      admin: "Admin Panel",
      login: "Log In",
      register: "Register",
      logout: "Log Out",
      about: "About",
      contact: "Contact",
      createListing: "List Material",
    },
    // ── Buttons ──
    btn: {
      submit: "Submit",
      cancel: "Cancel",
      login: "Log In",
      register: "Create Account",
      search: "Search",
      filter: "Filter",
      save: "Save",
      edit: "Edit",
      delete: "Delete",
      approve: "Approve",
      reject: "Reject",
      accept: "Accept",
      decline: "Decline",
      counter: "Counter Offer",
      makeOffer: "Make Offer",
      viewDetails: "View Details",
      bookNow: "Book Now",
      loadMore: "Load More",
      back: "Back",
      next: "Next",
      previous: "Previous",
      markPaid: "Mark as Paid",
      confirmReceipt: "Confirm Receipt",
      scheduleVisit: "Schedule Visit",
      createListing: "List Material",
      resendCode: "Resend Code",
      verifyCode: "Verify Code",
      browseMarket: "Browse Marketplace",
      findTech: "Find Technician",
      viewMap: "View Map",
      getStarted: "Get Started",
      learnMore: "Learn More",
      sendMessage: "Send Message",
      applyNow: "Apply Now",
    },
    // ── Form Labels ──
    form: {
      name: "Full Name",
      email: "Email Address",
      password: "Password",
      confirmPassword: "Confirm Password",
      phone: "Phone Number",
      role: "Account Type",
      sector: "Sector / Location",
      district: "District",
      specialization: "Specialization",
      company: "Company Name",
      title: "Title",
      description: "Description",
      material: "Material Type",
      condition: "Condition",
      quantity: "Quantity",
      price: "Price (RWF)",
      paymentMethod: "Payment Method",
      paymentNumber: "Payment Number",
      amount: "Offer Amount (RWF)",
      message: "Message",
      deviceType: "Device Type",
      problem: "Problem Description",
      preferredDate: "Preferred Date",
      verificationCode: "Verification Code",
      subject: "Subject",
      currentPassword: "Current Password",
      newPassword: "New Password",
      offerAmount: "Your Offer (RWF)",
    },
    // ── Status Labels ──
    status: {
      pending: "Pending",
      available: "Available",
      approved: "Approved",
      rejected: "Rejected",
      pending_review: "Under Review",
      accepted: "Accepted",
      countered: "Countered",
      declined: "Declined",
      in_transit: "In Transit",
      completed: "Completed",
      verified: "Verified",
      unverified: "Pending Approval",
      active: "Active",
      inactive: "Inactive",
      open: "Open",
      closed: "Closed",
      paid: "Paid",
      unpaid: "Unpaid",
    },
    // ── Roles ──
    roles: {
      citizen: "Citizen",
      buyer: "Buyer",
      technician: "Technician",
      recycler: "Recycler",
      admin: "Admin",
      citizenDesc: "List recyclable materials and connect with buyers or technicians.",
      buyerDesc: "Purchase recycled materials and make counter-offers.",
      technicianDesc: "Offer repair and maintenance services across Rwanda.",
      recyclerDesc: "Source raw materials and grow your recycling business.",
    },
    // ── Page Headings ──
    pages: {
      home: "RECYX",
      marketplace: "Marketplace",
      technicians: "Find Technicians",
      map: "Recycling Map",
      dashboard: "Dashboard",
      admin: "Admin Panel",
      login: "Welcome Back",
      register: "Create Account",
      about: "About RECYX",
      contact: "Contact Us",
      careers: "Careers at RECYX",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      createListing: "List a Material",
    },
    // ── Hero Slides ──
    hero: {
      slide1: {
        badge: "Serving All 30 Districts",
        headline: "Rwanda's Digital Recycling Platform",
        sub: "Connect with verified buyers, recyclers, and repair technicians across Rwanda. Turn waste into value.",
        cta1: "Browse Marketplace",
        cta2: "Learn More",
      },
      slide2: {
        badge: "2,500+ Verified Repairs",
        headline: "Fix It Before You Bin It",
        sub: "Find certified repair technicians near you - smartphones, laptops, appliances and more. Same-day bookings available.",
        cta1: "Find Technician",
        cta2: "How It Works",
      },
      slide3: {
        badge: "Vision 2050 Aligned",
        headline: "Turn Waste Into Wealth",
        sub: "List your recyclable materials, negotiate prices, and get paid via MTN MoMo or Airtel Money. Join 5,000+ users today.",
        cta1: "List Material",
        cta2: "View Map",
      },
    },
    // ── Stats ──
    stats: {
      repairs: "Verified Repairs",
      listings: "Active Listings",
      centers: "Recycling Centers",
      districts: "Districts Covered",
    },
    // ── Features ──
    features: {
      heading: "Why Choose RECYX?",
      sub: "A complete digital ecosystem for Rwanda's circular economy - from repair to recycling.",
      repair: { title: "Verified Repairs", desc: "Certified technicians across all 30 districts. Rated and reviewed by real users." },
      marketplace: { title: "Waste Marketplace", desc: "List and buy recyclable materials with counter-offer negotiations and live pricing." },
      network: { title: "Recycling Network", desc: "Connect to 45+ certified recycling facilities mapped across Rwanda." },
      map: { title: "Interactive Maps", desc: "Find the nearest repair shop, recycling center, or collection point instantly." },
      ratings: { title: "Rating System", desc: "Transparent star ratings and reviews for technicians and recyclers alike." },
      payments: { title: "Secure Payments", desc: "MTN MoMo and Airtel Money integration - pay and get paid safely." },
    },
    // ── How It Works ──
    howItWorks: {
      heading: "How RECYX Works",
      sub: "Four simple steps to start contributing to Rwanda's circular economy.",
      steps: [
        { num: "01", title: "Register", desc: "Create your account and choose your role - citizen, buyer, technician, or recycler." },
        { num: "02", title: "List or Search", desc: "List your recyclable materials or search for what you need in the marketplace." },
        { num: "03", title: "Connect & Negotiate", desc: "Make or receive offers, counter-offer, and agree on a fair price." },
        { num: "04", title: "Complete & Pay", desc: "Finalize the transaction via MTN MoMo or Airtel Money. Leave a review!" },
      ],
    },
    // ── Testimonials ──
    testimonials: {
      heading: "What Our Users Say",
      sub: "Real stories from citizens, technicians, and recyclers across Rwanda.",
    },
    // ── CTA Banner ──
    cta: {
      heading: "Join Rwanda's Circular Economy",
      sub: "5,000+ users are already reducing waste and earning income through RECYX. Start today.",
      btn1: "Get Started Free",
      btn2: "Browse Marketplace",
    },
    // ── Footer ──
    footer: {
      tagline: "Rwanda's digital platform for recycling, repair, and circular economy.",
      links: "Quick Links",
      legal: "Legal",
      contact: "Contact",
      about: "About",
      careers: "Careers",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      copyright: "© 2026 RECYX. Methode Duhujubumwe - African Leadership University.",
      address: "African Leadership University, Kigali Innovation City, Kigali, Rwanda",
      hours: "Mon–Fri 8am–6pm, Sat 9am–1pm",
    },
    // ── Errors ──
    errors: {
      required: "This field is required",
      invalidEmail: "Please enter a valid email address",
      passwordTooShort: "Password must be at least 8 characters",
      passwordMismatch: "Passwords do not match",
      invalidCode: "Invalid verification code",
      loginFailed: "Invalid email or password",
      uploadTooLarge: "File too large. Maximum size is 5MB",
      networkError: "Network error. Please try again.",
      unauthorized: "You must be logged in to do this.",
      adminOnly: "This area is for admins only.",
      noImage: "Please upload at least one image",
    },
    // ── Success ──
    success: {
      listingCreated: "Listing submitted for admin review!",
      offerMade: "Offer submitted successfully!",
      offerAccepted: "Offer accepted! Proceed to payment.",
      offerDeclined: "Offer declined.",
      counterSent: "Counter-offer sent!",
      userApproved: "Account approved successfully.",
      userRejected: "Account rejected.",
      listingApproved: "Listing approved and now live.",
      listingRejected: "Listing removed.",
      messageSent: "Message sent! We'll reply within 24 hours.",
      registered: "Account created! Check your email for verification.",
      loggedOut: "Logged out successfully.",
      bookingCreated: "Service request submitted!",
      visitScheduled: "Visit scheduled.",
      paid: "Payment marked. Awaiting seller confirmation.",
      receiptConfirmed: "Receipt confirmed. Transaction complete!",
    },
    // ── Dashboard Labels ──
    dash: {
      welcome: "Welcome back",
      activeListings: "Active Listings",
      receivedOffers: "Received Offers",
      completedTx: "Completed Transactions",
      activeOffers: "Active Offers",
      savedItems: "Saved Items",
      jobsCompleted: "Jobs Completed",
      activeRequests: "Active Requests",
      earnings: "Total Earnings (RWF)",
      rating: "Average Rating",
      co2Saved: "CO₂ Saved (kg)",
      materialsAcquired: "Materials Acquired (kg)",
      quickActions: "Quick Actions",
      myListings: "My Listings",
      notifications: "Notifications",
      noNotifications: "No new notifications",
      pendingUsers: "Pending Users",
      pendingListings: "Pending Listings",
      totalUsers: "Total Users",
      activeTx: "Active Transactions",
    },
    // ── Admin Tabs ──
    admin: {
      accounts: "Account Requests",
      listings: "Listing Review",
      transactions: "Transactions",
      noRequests: "No pending requests",
      noListings: "No listings under review",
      noTransactions: "No active transactions",
    },
    // ── Payment ──
    payment: {
      heading: "Complete Payment",
      chooseMethod: "Choose Payment Method",
      mtnMomo: "MTN Mobile Money",
      airtelMoney: "Airtel Money",
      sellerInfo: "Seller Payment Details",
      sellerPhone: "Send payment to:",
      yourRef: "Use listing ID as reference",
      markPaid: "I have sent the payment",
      confirmReceipt: "I have received the payment",
      pending: "Waiting for payment confirmation...",
      txComplete: "Transaction Complete",
    },
    // ── Map ──
    map: {
      heading: "Recycling & Repair Map",
      sub: "Find recycling centers, repair shops, and collection points near you.",
      allTypes: "All Types",
      recyclers: "Recycling Centers",
      repairs: "Repair Shops",
      collection: "Collection Points",
      clickToZoom: "Click a facility to zoom in",
      noResults: "No facilities match your filter.",
    },
    // ── Marketplace ──
    market: {
      heading: "Material Marketplace",
      sub: "Browse, negotiate, and purchase recyclable materials across Rwanda.",
      noResults: "No listings match your search.",
      sort: {
        newest: "Newest First",
        priceAsc: "Price: Low to High",
        priceDesc: "Price: High to Low",
        mostViewed: "Most Viewed",
      },
      filters: { all: "All", electronics: "Electronics", plastic: "Plastic", metal: "Metal", paper: "Paper", glass: "Glass", mixed: "Mixed" },
      detail: {
        seller: "Seller",
        material: "Material",
        condition: "Condition",
        quantity: "Quantity",
        sector: "Location",
        listed: "Listed",
        views: "views",
        offers: "Offers",
        noOffers: "No offers yet. Be the first!",
        makeOffer: "Make an Offer",
        yourOffer: "Your Offer Amount (RWF)",
        offerMsg: "Message to Seller (optional)",
        loginToOffer: "Log in to make an offer",
      },
    },
    // ── Register Steps ──
    register: {
      step1: "Basic Info",
      step2: "Security",
      step3: "Verify Email",
      chooseRole: "Choose your account type",
      passwordStrength: { weak: "Weak", fair: "Fair", good: "Good", strong: "Strong" },
      verifyDesc: "We sent a 6-digit code to your email. Enter it below to verify your account.",
      pendingDesc: "Your account is pending admin approval. You'll receive an email when approved.",
    },
    // ── Technicians ──
    tech: {
      heading: "Find a Technician",
      sub: "Verified repair experts across all 30 Rwanda districts.",
      specs: { all: "All Specializations", smartphones: "Smartphones", laptops: "Laptops & Computers", appliances: "Home Appliances", tvs: "TVs & Monitors", solar: "Solar Panels", printers: "Printers & Copiers" },
      book: {
        heading: "Book Technician",
        device: "Device Type",
        problem: "Describe the Problem",
        date: "Preferred Date & Time",
        contact: "Your Contact Info",
        submit: "Send Request",
      },
      jobsCompleted: "jobs",
      yearsExp: "yrs exp",
      noResults: "No technicians match your search.",
    },
  },

  // ═══════════════════════════════════════════
  // KINYARWANDA
  // ═══════════════════════════════════════════
  rw: {
    nav: {
      home: "Ahabanza",
      marketplace: "Isoko",
      technicians: "Abatekinsiye",
      map: "Ikarita",
      dashboard: "Imbaho",
      admin: "Imbaho y'Ubutegetsi",
      login: "Injira",
      register: "Iyandikishe",
      logout: "Sohoka",
      about: "Abo Turi Bo",
      contact: "Twandikire",
      createListing: "Tangaza Ibikoresho",
    },
    btn: {
      submit: "Ohereza",
      cancel: "Reka",
      login: "Injira",
      register: "Fungura Konti",
      search: "Shakisha",
      filter: "Shungura",
      save: "Bika",
      edit: "Hindura",
      delete: "Siba",
      approve: "Emeza",
      reject: "Hakana",
      accept: "Emera",
      decline: "Hakana",
      counter: "Subiza Igiciro",
      makeOffer: "Tanga Igiciro",
      viewDetails: "Reba Birambuye",
      bookNow: "Buka Ubu",
      loadMore: "Birenzeho",
      back: "Subira Inyuma",
      next: "Komeza",
      previous: "Ibanza",
      markPaid: "Emeza ko Wishyuye",
      confirmReceipt: "Emeza Kwakira",
      scheduleVisit: "Shyira Ingendo mu Gahunda",
      createListing: "Tangaza Ibikoresho",
      resendCode: "Ohereza Code Ubundi",
      verifyCode: "Emeza Code",
      browseMarket: "Reba Isoko",
      findTech: "Shakisha Umutekinsiye",
      viewMap: "Reba Ikarita",
      getStarted: "Tangira",
      learnMore: "Menya Birenzeho",
      sendMessage: "Ohereza Ubutumwa",
      applyNow: "Saba Akazi Ubu",
    },
    form: {
      name: "Amazina Yuzuye",
      email: "Aderesi ya Email",
      password: "Ijambo Banga",
      confirmPassword: "Emeza Ijambo Banga",
      phone: "Nomero ya Telefoni",
      role: "Ubwoko bw'Konti",
      sector: "Akagari / Akarere",
      district: "Akarere",
      specialization: "Inzobere mu",
      company: "Izina ry'Ikigo",
      title: "Umutwe",
      description: "Ibisobanuro",
      material: "Ubwoko bw'Ibikoresho",
      condition: "Imiterere",
      quantity: "Ingano",
      price: "Igiciro (RWF)",
      paymentMethod: "Uburyo bwo Kwishyura",
      paymentNumber: "Nomero yo Kwishyura",
      amount: "Umubare w'Igiciro (RWF)",
      message: "Ubutumwa",
      deviceType: "Ubwoko bw'Igikoresho",
      problem: "Ibisobanuro by'Ikibazo",
      preferredDate: "Itariki Wishakira",
      verificationCode: "Code y'Irangamimerere",
      subject: "Insanganyamatsiko",
      currentPassword: "Ijambo Banga Ry'ubu",
      newPassword: "Ijambo Banga Rishya",
      offerAmount: "Igiciro Cyawe (RWF)",
    },
    status: {
      pending: "Birategerezwa",
      available: "Biraboneka",
      approved: "Byemejwe",
      rejected: "Byanzwe",
      pending_review: "Birareberwa",
      accepted: "Byaremwe",
      countered: "Byasubizwa Igiciro",
      declined: "Byahakanwe",
      in_transit: "Mu Nzira",
      completed: "Byarangiye",
      verified: "Byemejwe",
      unverified: "Birategerezwa Kwemezwa",
      active: "Bikora",
      inactive: "Ntibikorwa",
      open: "Byafunguwe",
      closed: "Byafunzwe",
      paid: "Wishyuwe",
      unpaid: "Ntawishyuwe",
    },
    roles: {
      citizen: "Umuturage",
      buyer: "Umugura",
      technician: "Umutekinsiye / Umufundi",
      recycler: "Umucuruzi w'Imyanda",
      admin: "Umuyobozi",
      citizenDesc: "Tangaza ibikoresho by'imyanda kandi ubonane n'abagura cyangwa abatekinsiye.",
      buyerDesc: "Gura ibikoresho bisubizwa kandi utange ibiciro bishya.",
      technicianDesc: "Tanga serivisi zo gusana no gufata neza mu turere twose 30.",
      recyclerDesc: "Shakisha ibikoresho bishamirwa no gutera imbere ubucuruzi bwawe.",
    },
    pages: {
      home: "RECYX",
      marketplace: "Isoko",
      technicians: "Shakisha Abatekinsiye",
      map: "Ikarita y'Iyoherezwa",
      dashboard: "Imbaho",
      admin: "Imbaho y'Ubutegetsi",
      login: "Murakaza neza",
      register: "Fungura Konti",
      about: "Abo Turi Bo",
      contact: "Twandikire",
      careers: "Akazi muri RECYX",
      privacy: "Politiki y'Ibanga",
      terms: "Amabwiriza y'Imikoreshereze",
      createListing: "Tangaza Ibikoresho",
    },
    hero: {
      slide1: {
        badge: "Tureba Turere Twose 30",
        headline: "Urubuga rwa Dijitali rwo Gucuruza Imyanda mu Rwanda",
        sub: "Buhuje n'abagura bemejwe, abasubiramo imyanda, n'abatekinsiye ku isi yose mu Rwanda. Hindura imyanda ibe ingenzi.",
        cta1: "Reba Isoko",
        cta2: "Menya Birenzeho",
      },
      slide2: {
        badge: "Amasanamu 2,500+ Emejwe",
        headline: "Sana Mbere yo Guta",
        sub: "Shakisha abatekinsiye bemejwe hafi yawe - smartphones, laptops, ibikoresho by'amazu no kurushaho. Buka uyu munsi.",
        cta1: "Shakisha Umutekinsiye",
        cta2: "Bikorwa Bite",
      },
      slide3: {
        badge: "Vision 2050 Ijyanye na We",
        headline: "Hindura Imyanda ibe Ubutunzi",
        sub: "Tangaza ibikoresho by'imyanda, negosia ibiciro, kandi wishyurwe ukoresheje MTN MoMo cyangwa Airtel Money. Winjire hamwe na 5,000+ bakoresheje.",
        cta1: "Tangaza Ibikoresho",
        cta2: "Reba Ikarita",
      },
    },
    stats: {
      repairs: "Amasanamu Yemejwe",
      listings: "Ibicuruzwa Bikora",
      centers: "Aho Imyanda Yoherezwa",
      districts: "Turere Twose",
    },
    features: {
      heading: "Kubera Iki RECYX?",
      sub: "Sisitemu yuzuye ya dijitali y'ubukungu bw'imyanda - kuva mu gusana kugeza ku gusubiza.",
      repair: { title: "Amasanamu Yemejwe", desc: "Abatekinsiye bemejwe mu turere twose 30. Bayagizwe amanota no gusubirwaho n'abakoresheje nyakuri." },
      marketplace: { title: "Isoko y'Imyanda", desc: "Tangaza kandi ugure ibikoresho by'imyanda ukoresheje inegosiasyo y'ibiciro n'ibiciro bya live." },
      network: { title: "Umuyoboro w'Iyoherezwa", desc: "Buhuje n'aho imyanda yoherezwa 45+ byemejwe ku ikarita mu Rwanda." },
      map: { title: "Amakarita Akora", desc: "Shakisha aho gusana hafi, aho imyanda yoherezwa, cyangwa ahantu h'itegurwa vuba." },
      ratings: { title: "Sisitemu y'Amanota", desc: "Amanota y'inyenyeri ziseseka n'ibitekerezo ku batekinsiye n'abasubiramo imyanda." },
      payments: { title: "Ubwishyu Bwizewe", desc: "Guhuza na MTN MoMo na Airtel Money - wishyure no kwishyurwa mu mutekano." },
    },
    howItWorks: {
      heading: "RECYX Ikorwa Bite",
      sub: "Intambwe enye zoroheje zo gutangira gutera inkunga ubukungu bw'imyanda mu Rwanda.",
      steps: [
        { num: "01", title: "Iyandikishe", desc: "Fungura konti yawe uhitemo inshingano - umuturage, umugura, umutekinsiye, cyangwa umucuruzi w'imyanda." },
        { num: "02", title: "Tangaza cyangwa Shakisha", desc: "Tangaza ibikoresho by'imyanda cyangwa shakisha ibikenewe mu isoko." },
        { num: "03", title: "Buhuzwa no Kunegosia", desc: "Tanga cyangwa akira ibiciro, subiramo, kandi rikirana igiciro gikwiye." },
        { num: "04", title: "Rangiza no Kwishyura", desc: "Rangiza ubucuruzi ukoresheje MTN MoMo cyangwa Airtel Money. Tanga ibitekerezo!" },
      ],
    },
    testimonials: {
      heading: "Abakoresheje Bavuga Iki",
      sub: "Inkuru nyakuri z'abatuye, abatekinsiye, n'abasubiramo imyanda mu Rwanda.",
    },
    cta: {
      heading: "Injira mu Bukungu bw'Imyanda mu Rwanda",
      sub: "Abakoresheje 5,000+ barashora bagabanya imyanda kandi bakinjiza amafaranga binyuze kuri RECYX. Tangira uyu munsi.",
      btn1: "Tangira Ubuntu",
      btn2: "Reba Isoko",
    },
    footer: {
      tagline: "Urubuga rwa dijitali rw'u Rwanda rwo gusubiramo imyanda, gusana, n'ubukungu bw'imyanda.",
      links: "Inyungu Ngufi",
      legal: "Amategeko",
      contact: "Twandikire",
      about: "Abo Turi Bo",
      careers: "Akazi",
      privacy: "Politiki y'Ibanga",
      terms: "Amabwiriza",
      copyright: "© 2026 RECYX. Methode Duhujubumwe - African Leadership University.",
      address: "African Leadership University, Kigali Innovation City, Kigali, Rwanda",
      hours: "Guhera Ku wa 1 kugeza Ku wa 5 8am–6pm, Ku wa 6 9am–1pm",
    },
    errors: {
      required: "Iki gice gisabwa",
      invalidEmail: "Injiza aderesi ya email ikwiye",
      passwordTooShort: "Ijambo banga rigomba kuba nibura inyuguti 8",
      passwordMismatch: "Amagambo banga ntangana",
      invalidCode: "Code ntizi",
      loginFailed: "Email cyangwa ijambo banga ntizi",
      uploadTooLarge: "Dosiye nini cyane. Ingano ntarengwa ni 5MB",
      networkError: "Ikibazo cy'umuyoboro. Ongera ugerageze.",
      unauthorized: "Ugomba kwinjira gukora ibi.",
      adminOnly: "Aha ni ahabereye abayobozi gusa.",
      noImage: "Injiza ifoto imwe nibura",
    },
    success: {
      listingCreated: "Itangazo ryoherejwe ku buyobozi kugirango rireberwe!",
      offerMade: "Igiciro cyoherejwe neza!",
      offerAccepted: "Igiciro cyaremwe! Komeza kwishyura.",
      offerDeclined: "Igiciro cyahakanwe.",
      counterSent: "Igiciro gishya cyoherejwe!",
      userApproved: "Konti yemejwe neza.",
      userRejected: "Konti yanzwe.",
      listingApproved: "Itangazo ryemejwe kandi rikora.",
      listingRejected: "Itangazo ryakuweho.",
      messageSent: "Ubutumwa bwoherejwe! Tuzagusubiza mu masaha 24.",
      registered: "Konti yafunguwe! Reba email yawe kugirango wemeze.",
      loggedOut: "Wasohokeyemo neza.",
      bookingCreated: "Icyifuzo cya serivisi cyoherejwe!",
      visitScheduled: "Ingendo yashyizwe mu gahunda.",
      paid: "Ubwishyu bwemejwe. Tegereza ko umucuruzi abyemeza.",
      receiptConfirmed: "Kwakira kwemejwe. Ubucuruzi burangiye!",
    },
    dash: {
      welcome: "Murakaza neza",
      activeListings: "Amatangazo Akora",
      receivedOffers: "Ibiciro Byakiriwe",
      completedTx: "Ubucuruzi Bwarangiye",
      activeOffers: "Ibiciro Bikora",
      savedItems: "Ibitunzwe",
      jobsCompleted: "Imirimo Yarangiye",
      activeRequests: "Ibyifuzo Bikora",
      earnings: "Inyungu Yose (RWF)",
      rating: "Amanota Hagati",
      co2Saved: "CO₂ Yabitswe (kg)",
      materialsAcquired: "Ibikoresho Byakuwe (kg)",
      quickActions: "Ibikorwa Vuba",
      myListings: "Amatangazo Yanjye",
      notifications: "Imenyesha",
      noNotifications: "Nta menyesha mashya",
      pendingUsers: "Abakoresheje Bategerewe",
      pendingListings: "Amatangazo Ategerewe",
      totalUsers: "Abakoresheje Bose",
      activeTx: "Ubucuruzi Bukora",
    },
    admin: {
      accounts: "Ibyifuzo bya Konti",
      listings: "Isuzuma ry'Amatangazo",
      transactions: "Ubucuruzi",
      noRequests: "Nta byifuzo byategerezwa",
      noListings: "Nta matangazo ategerewe",
      noTransactions: "Nta bucuruzi bukora",
    },
    payment: {
      heading: "Rangiza Kwishyura",
      chooseMethod: "Hitamo Uburyo bwo Kwishyura",
      mtnMomo: "MTN Mobile Money",
      airtelMoney: "Airtel Money",
      sellerInfo: "Amakuru y'Ubwishyu bw'Umucuruzi",
      sellerPhone: "Ohereza ubwishyu kuri:",
      yourRef: "Koresha ID y'itangazo nk'umusomero",
      markPaid: "Noherejwe ubwishyu",
      confirmReceipt: "Nakiriwe ubwishyu",
      pending: "Tegereza ko ubwishyu bwemezwa...",
      txComplete: "Ubucuruzi Burangiye",
    },
    map: {
      heading: "Ikarita y'Iyoherezwa no Gusana",
      sub: "Shakisha aho imyanda yoherezwa, aho gusana, n'ahantu h'itegurwa hafi yawe.",
      allTypes: "Ubwoko Bwose",
      recyclers: "Aho Imyanda Yoherezwa",
      repairs: "Amaduka yo Gusana",
      collection: "Ahantu h'Itegurwa",
      clickToZoom: "Kanda ku gikoresho kugirango ugure hafi",
      noResults: "Nta bikoresho bishobora ukutoshyirwa.",
    },
    market: {
      heading: "Isoko y'Ibikoresho",
      sub: "Reba, negosia, kandi ugure ibikoresho bisubizwa mu Rwanda.",
      noResults: "Nta tangazo rihuye n'ushakisha.",
      sort: {
        newest: "Bishya Mbere",
        priceAsc: "Igiciro: Hasi kugeza Hejuru",
        priceDesc: "Igiciro: Hejuru kugeza Hasi",
        mostViewed: "Birebwe Cyane",
      },
      filters: { all: "Byose", electronics: "Ikoranabuhanga", plastic: "Plastike", metal: "Icuma", paper: "Amapapuro", glass: "Vitre", mixed: "Ivangavange" },
      detail: {
        seller: "Umucuruzi",
        material: "Ibikoresho",
        condition: "Imiterere",
        quantity: "Ingano",
        sector: "Ahantu",
        listed: "Yaratangazwe",
        views: "ibyerekewe",
        offers: "Ibiciro",
        noOffers: "Nta biciro birahari. Ube wa mbere!",
        makeOffer: "Tanga Igiciro",
        yourOffer: "Igiciro Cyawe (RWF)",
        offerMsg: "Ubutumwa ku Mucuruzi (si ngombwa)",
        loginToOffer: "Injira kugirango utange igiciro",
      },
    },
    register: {
      step1: "Amakuru Ibanze",
      step2: "Umutekano",
      step3: "Emeza Email",
      chooseRole: "Hitamo ubwoko bw'konti yawe",
      passwordStrength: { weak: "Nta ngufu", fair: "Hagati", good: "Nziza", strong: "Komeye cyane" },
      verifyDesc: "Twoherejwe code y'imibare 6 kuri email yawe. Injiza hasi kugirango wemeze konti yawe.",
      pendingDesc: "Konti yawe irategerezwa kwemezwa n'umuyobozi. Uzakira email igihe yemejwe.",
    },
    tech: {
      heading: "Shakisha Umutekinsiye",
      sub: "Inzobere mu gusana zemejwe mu turere twose 30 tw'u Rwanda.",
      specs: { all: "Ubumenyi Bwose", smartphones: "Smartphones", laptops: "Laptops & Mudasobwa", appliances: "Ibikoresho by'Amazu", tvs: "TVs & Monitors", solar: "Panels ya Izuba", printers: "Impapuro z'Ibikoresho" },
      book: {
        heading: "Buka Umutekinsiye",
        device: "Ubwoko bw'Igikoresho",
        problem: "Sobanura Ikibazo",
        date: "Itariki n'Igihe Wishakira",
        contact: "Amakuru Yawe y'Gutumanahana",
        submit: "Ohereza Icyifuzo",
      },
      jobsCompleted: "imirimo",
      yearsExp: "imyaka y'uburambe",
      noResults: "Nta mutekinsiye uhuye n'ushakisha.",
    },
  },
};

export default T;
